import { useDispatch, useSelector } from "react-redux";
import Split from "react-split";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import NtwLeftPanel from "./NtwLeftPanel";
import NtwRightPanel from "./NtwRightPanel";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";

const styles = {
  container: {
    boxSizing: "border-box",
    border: "1px solid #e0e0e0",
    borderRadius: "5px"
  }, 
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    width: "30%",
    height: "100%",
    boxSizing: "border-box",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
    height: "100%",
    boxSizing: "border-box",
  },
  emptyPanel: {
    boxSizing: "border-box",
    border: "1px solid #e0e0e0",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
    color: "#b5b2ba",
    fontSize: "14px",
    height: "100%",
    paddingTop: "6px"
  },
  treeSearch: {
    height: "32px",
    padding: "5px 5px 0"
  },
  treeContainer: {
    flexGrow: 1,
    padding: "5px"
  }
}

export default function NewTemplateWizardModal({toggle}) {
  const dispatch = useDispatch();
  //const newTemplate = useSelector((state) => state.newTemplate);

  function onClose() {
    dispatch(newTemplateActions.resetState());
    toggle();
  }
  
  //make styles / class for these components. Inline styles kept here for example.
  return (
    <Split
      className="split height-100 flex"
      direction="horizontal"
      gutterSize={4}
      snapOffset={0}
      dragInterval={4}
      minSize={[550, 0]}
      sizes={[67, 33]}
    >
      <div
        className="flex-column height-100"
        style={{ backgroundColor: "#fff" }}
      >
        <div
          style={{ 
            borderBottom: "1px solid #e0e0e0", 
            height: "40px", 
            boxSizing: "border-box",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "500",
            paddingLeft: "16px",
          }}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            fontSize: "18px",
          }}>
            <span 
              className="WIZARD padding-right-8"
              style={{
                backgroundSize: "18px",
                width: "18px",
                height: "18px"
              }}
            ></span>
            New Template Wizard
          </div>
          <IconButton
            onClick={onClose}
            sx={{borderRadius: "5px"}}
          >
            <CloseIcon sx={{height: "28px", width: "28px", color: "#777777"}}/>
          </IconButton>
        </div>
        <Split
          style={{height: "calc(100% - 42px)"}}
          className="split width-100 flex"
          direction="horizontal"
          gutterSize={4}
          snapOffset={0}
          dragInterval={4}
          minSize={[200, 275]}
          sizes={[30, 70]}
        >
          <div style={styles.leftContainer}>
            <NtwLeftPanel/>
          </div>
          <div style={styles.rightContainer}>
            <NtwRightPanel toggle={toggle}/>
          </div>
        </Split>
      </div>
      <div></div>
    </Split>
  );
}
